export default "__VITE_ASSET__C73WJ8N1__"